import { createContext } from "react";
import { IMapOfString } from "global";

interface IMenuContext {
    goToUrl: (url: IMapOfString) => void;
    hideSubMenu: VoidFunction;
}

const EMPTY_FUNC = () => {
    /** DO NOTHING  */
};

const initialValue: IMenuContext = {
    goToUrl: EMPTY_FUNC,
    hideSubMenu: EMPTY_FUNC,
};

export default createContext(initialValue);
